import { GuestType } from 'src/api/api.generated'
import { Select as MuiSelect, SelectChangeEvent, Typography } from '@mui/material'
import { MenuItem, Select as VaporSelect, Stack } from '@vapor/material'
const Select = VaporSelect as unknown as typeof MuiSelect
import { displayGuestType } from 'src/utils/reservation'
import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCrown, faUser } from '@fortawesome/free-solid-svg-icons'
import { faUser as faUserRegular } from '@fortawesome/free-regular-svg-icons'

export type GuestTypeSelectProps = {
  group: boolean
  value: GuestType | null
  onChange: (value: GuestType | null) => void
  groupMemberConsiderAsSingleGuest: boolean
  error?: boolean
  disabled?: boolean
  size?: 'small' | 'medium'
}
export default function GuestTypeSelect({ group, value, onChange, groupMemberConsiderAsSingleGuest, error, disabled, size }: GuestTypeSelectProps) {
  const { t } = useTranslation()

  const selectOnChange = useCallback(
    (event: SelectChangeEvent<string>) => {
      let v: GuestType | null = null
      switch (event.target.value) {
        case GuestType.GROUP_HEAD:
          v = group ? GuestType.GROUP_HEAD : null
          break
        case GuestType.GROUP_MEMBER:
          v = group ? GuestType.GROUP_MEMBER : null
          break
        case GuestType.HEAD_OF_FAMILY:
          v = group ? null : GuestType.HEAD_OF_FAMILY
          break
        case GuestType.SINGLE_GUEST:
          v = group ? null : GuestType.SINGLE_GUEST
          break
        case GuestType.FAMILY:
          v = group ? null : GuestType.FAMILY
          break
        default:
          break
      }
      onChange(v)
    },
    [group, onChange],
  )

  return (
    <Select //
      size={size}
      fullWidth
      value={value || ''}
      onChange={selectOnChange}
      error={error}
      disabled={disabled}
      renderValue={(value) => {
        switch (value) {
          case GuestType.GROUP_HEAD:
            return <FontAwesomeIcon icon={faCrown} />
          case GuestType.GROUP_MEMBER:
            return <FontAwesomeIcon icon={faUserRegular} />
          case GuestType.HEAD_OF_FAMILY:
            return <FontAwesomeIcon icon={faCrown} />
          case GuestType.SINGLE_GUEST:
            return <FontAwesomeIcon icon={faUser} />
          case GuestType.FAMILY:
            return <FontAwesomeIcon icon={faUserRegular} />
          default:
            return ''
        }
      }}
    >
      <MenuItem
        value={GuestType.GROUP_HEAD} //
        disabled={!group}
        hidden={!group}
        style={{ display: groupMemberConsiderAsSingleGuest ? 'none' : group ? undefined : 'none' }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <FontAwesomeIcon icon={faCrown} />
          <Typography>{displayGuestType(t, GuestType.GROUP_HEAD)}</Typography>
        </Stack>
      </MenuItem>
      <MenuItem
        value={GuestType.GROUP_MEMBER} //
        disabled={!group}
        hidden={!group}
        style={{ display: groupMemberConsiderAsSingleGuest ? 'none' : group ? undefined : 'none' }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <FontAwesomeIcon icon={faUserRegular} />
          <Typography>{displayGuestType(t, GuestType.GROUP_MEMBER)}</Typography>
        </Stack>
      </MenuItem>

      <MenuItem
        value={GuestType.HEAD_OF_FAMILY} //
        disabled={group}
        hidden={group}
        style={{ display: groupMemberConsiderAsSingleGuest ? 'none' : !group ? undefined : 'none' }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <FontAwesomeIcon icon={faCrown} />
          <Typography>{displayGuestType(t, GuestType.HEAD_OF_FAMILY)}</Typography>
        </Stack>
      </MenuItem>
      <MenuItem
        value={GuestType.SINGLE_GUEST} //
        disabled={groupMemberConsiderAsSingleGuest ? false : group}
        hidden={group}
        style={{ display: groupMemberConsiderAsSingleGuest ? undefined : !group ? undefined : 'none' }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <FontAwesomeIcon icon={faUser} />
          <Typography>{displayGuestType(t, GuestType.SINGLE_GUEST)}</Typography>
        </Stack>
      </MenuItem>
      <MenuItem
        value={GuestType.FAMILY} //
        disabled={group}
        hidden={group}
        style={{ display: groupMemberConsiderAsSingleGuest ? 'none' : !group ? undefined : 'none' }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <FontAwesomeIcon icon={faUserRegular} />
          <Typography>{displayGuestType(t, GuestType.FAMILY)}</Typography>
        </Stack>
      </MenuItem>
      <MenuItem
        value={''} //
      >
        <Typography>{t('pms.components.guest_type.no_type')}</Typography>
      </MenuItem>
    </Select>
  )
}
